import { addClass, hasClass, removeClass } from '../support/classes';
import Component from './Component';

class Dropdown extends Component
{
    constructor(element, props)
    {
        super(element, props);

        this.state = {
            active: false,
        };

        this.initialize();

        this.bindEvents();
    }

    initialize()
    {
        this.handle = this.element.querySelector('.dropdown-handle');
        this.items = this.element.querySelector('.dropdown-items');
    }

    show()
    {
        addClass(this.element, 'active');

        document.addEventListener('click', this._handleDocumentClick);

        this.state.active = true;

        this.props.onOpen && this.props.onOpen();
    }

    hide()
    {
        removeClass(this.element, 'active');

        document.removeEventListener('click', this._handleDocumentClick);

        this.state.active = false;

        this.props.onClose && this.props.onClose();
    }

    _handleDocumentClick = (e) =>
    {
        if (this.element.contains(e.target))
        {
            return;
        }

        this.hide();
    }

    _handleClick = (e) =>
    {
        let target = e.target;

        while (target && target !== this.handle)
        {
            target = target.parentNode;
        }

        if (!target)
        {
            return;
        }

        this.state.active ? this.hide() : this.show();
    }

    bindEvents()
    {
        this.element.addEventListener('click', this._handleClick);
    }
}

export default Dropdown;